import { render } from "./BankTransfer.vue?vue&type=template&id=9dd2e1d2&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"

import "./BankTransfer.vue?vue&type=style&index=0&id=9dd2e1d2&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd2e1d2"]])

export default __exports__